<template>
  <div class="projectList">
    <div class="projectItem add">
      <div class="icon iconfont icon-add2" @click="showAddProjectDialog"></div>
      <div class="add_text">创建新项目</div>
    </div>
    <div class="projectItem" v-for="project in projectList" :key="project.team_no">
      <div class="content">
        <div class="team_name">{{project.team_name}}</div>
        <div class="introduction">{{project.introduction}}</div>
      </div>
      <div class="opts">
        <el-dropdown class="member_dropdown" trigger="click">
        <span class="el-dropdown-link member">
          <i class="icon iconfont icon-renyuan"></i>
          <span>{{project.userList.length}}</span>
        </span>
          <el-dropdown-menu class="member_dropdown_menu" slot="dropdown">
            <el-dropdown-item class="invite_new_member"><div><i class="el-icon-circle-plus"></i>邀请新同事</div></el-dropdown-item>
            <split></split>
            <el-dropdown-item v-for="user in project.userList" :key="user.user_no"><div>{{user.username}}</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="more_dropdown" trigger="click">
        <span class="el-dropdown-link more">
          <i class="el-icon-more"></i>
        </span>
          <el-dropdown-menu class="more_dropdown_menu" slot="dropdown">
            <el-dropdown-item><div @click="showEditProjectDialog(project.team_no)"><i class="el-icon-edit-outline"></i>编辑</div></el-dropdown-item>
            <split></split>
            <el-dropdown-item class="delete"><div @click="deleteProject(project.team_no)"><i class="el-icon-delete"></i>删除</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <dialogProject :addProjectDialogVisible="addProjectDialogVisible" :projecttype="projecttype" @closeAddProjectDialog="closeAddProjectDialog"></dialogProject>
  </div>
</template>

<script type="text/ecmascript-6">
import split from './split_line_1px.vue'
import dialogProject from './dialogProject.vue'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
  name: 'projectList',
  components: {
    split,
    dialogProject
  },
  data: function () {
    return {
      addProjectDialogVisible: false,
      projecttype: {
        method: '',
        team_no: ''
      }
    }
  },
  computed: {
    ...mapState([
      'projectList'
    ])
  },
  methods: {
    showAddProjectDialog () {
      this.projecttype.method = 'add'
      this.addProjectDialogVisible = true
    },
    showEditProjectDialog (teamNo) {
      console.log('showEditProjectDialog')
      console.log(teamNo)
      this.projecttype.method = 'edit'
      this.projecttype.team_no = teamNo
      this.addProjectDialogVisible = true
    },
    closeAddProjectDialog () {
      this.addProjectDialogVisible = false
    },
    deleteProject (teamNo) {
      let _this = this
      axios({
        method: 'get',
        url: _this.HOST + '/company/updateTeam',
        params: {
          team_no: teamNo,
          is_delete: 1
        }
      }).then((res) => {
        let data = res.data
        console.log('删除项目')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setProjectList')
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .more_dropdown_menu
    width 5.625rem
  .member_dropdown_menu
    width 9.375rem
  .more_dropdown_menu,.member_dropdown_menu
    padding 0
    .el-dropdown-menu__item
      padding 0
      div
        padding 0 1.0625rem
    li:hover
      color $white !important
      background-color $elemBlue !important
    li
      height 2rem
      line-height 2rem !important
      color $tinGrey
      font-size 0.75rem
      text-align left
      i
        margin-right 0.625rem
    .delete
      color $darkRed
    .invite_new_member
      color $elemBlue
    .split_line_1px
      width 80%
      margin-left 10%
  .projectList
    height 98%
    overflow-y auto
    .projectItem.add
      display block
    .projectItem
      min-height 2.5625rem
      margin 0.625rem 0.125rem
      padding 1rem 1rem 0.5rem 1rem
      background $white
      border-radius 0.75rem
      box-shadow:0 0.125rem 0.25rem 0 $tinGrey
      display flex
      display -webkit-flex
      .icon-add2
        color $elemBlue
        text-align center
        font-size 2rem
        cursor pointer
      .add_text
        padding-top 0.25rem
        text-align center
      .content
        flex 3
        .introduction
          margin-top 0.5rem
          font-size 0.875rem
          color $lightGrey
      .opts
        flex 1
        text-align center
        font-size 0.875rem
        padding-top 0.25rem
        .member_dropdown
          margin-right 0.625rem
        .member_dropdown,.more_dropdown
          cursor pointer
          color $tinGrey
        .member_dropdown:hover,.more_dropdown:hover
          color $elemBlue
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/projectList.vue